module.exports = __webpack_public_path__ + "media/images/smart_phone/sp_menu-2235168cbb084d1e1f61cae9d2405bd8.png";